<template>
    <img src="/images/promo/hero-section/gear.png"
     alt="Gear" />
</template>

<script>
export default {};
</script>
